/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Card,
  Divider,
  HStack,
  Heading,
  Scrollable,
  Stack,
  Text,
  Wrap,
  WrapItem,
  Tooltip,
  IconButton,
  Box,
} from '@mybridge/ui';
import { MyProfileActivity } from 'v4/components/public-profile/activity';
import {
  ChatIcon,
  Eye,
  EyeViewIcon,
  FollowIcon,
  FollowingIcon,
  HandShakeSimpleIcon,
} from '@mybridge/icons';
import { MyProfileIntroduction } from 'v4/components/public-profile/introduction';
import { MyProfilePersonalInfo } from 'v4/components/public-profile/personal-info';
import { MyProfileDegreeConnections } from 'v4/components/public-profile/degree-connections';
import { useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import { ManageTestimonialIcon } from '@mybridge/icons';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyProfileNetworkSuggestionsList } from 'v4/components/public-profile/suggestions-list';
import Link from 'next/link';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { MyNetworkCircleCardMenu } from '../../network/circle-menu';
import { isMobile } from 'react-device-detect';
import MyPublicArticlesList from 'v4/components/public-profile/articles';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyPublicProfileArticles = () => {
  const { t } = useTranslator();
  const {
    connections,
    publicProfile,
    userProfileInfo,
    hasPersonalInfo,
    hasIntro,
    loggedIn,
    refetchConnections,
    mutualConnections,
    refetchMutualConnections,
    hasWebsite,
    hasInterestedIn,
    hasCauses,
    hasLinks,
  } = useContext(PublicProfileContext);
  const {
    handshakeUser,
    handshakeLoading,
    isHandshaked,
    followUser,
    followLoading,
    unfollowUser,
    unfollowLoading,
    isFollowed,
    isHandshakedRequested,
    isFriend,
    allSuggestions,
    refetchSuggestions,
    unfriendLoading,
    selectedUser,
    setSelectedUser,
    setHandshakeSelectedUser,
    handshakeMessageDisc,
    handleHandshakeSendRevoke,
    revokeHandshakeLoading,
    filters = {},
  } = useContext(MyNetworkContext);
  const { startChatSingle } = useContext(MatrixContext);
  const { profile_intro: intro, profile_headline: headline } =
    userProfileInfo ?? {};

  useEffect(() => {
    refetchConnections?.();
    refetchMutualConnections?.();
  }, []);

  const handleProfileHandshake = (user) => {
    setHandshakeSelectedUser(user);
    handshakeMessageDisc?.onOpen();
  };

  // console.log(hasWebsite, hasInterestedIn, hasCauses, hasLinks, publicProfile);

  return (
    <>
      <Stack direction={['column', 'row']} spacing={4} alignItems="flex-start">
        <Stack w={['100%', '100%', '100%']} spacing={6} p={[2, 0]}>
          <MyPublicArticlesList />
        </Stack>
      </Stack>
    </>
  );
};
